import React from 'react';
import ChoiceWrap from '../../components/ui/forms/ChoiceWrap';
import DoubleWrap from '../ui/forms/DoubleWrap';
import InputWrap from '../ui/forms/InputWrap';
import BoxedInput from '../shared/forms/BoxedInput';
import BoxedSelect from '../shared/forms/BoxedSelect';
import FormTextWrap from '../ui/forms/FormTextWrap';
import Label from '../ui/forms/Label';
import FileButton from '../ui/forms/file/FileButton';
import FileUpload from '../ui/forms/file/FileUpload';
import FileClose from '../ui/forms/file/FileClose';
import FileLabelWrapper from '../ui/forms/file/FileLabelWrapper';
import File from '../ui/forms/file/File';
import FormWrapper from '../ui/forms/FormWrapper';
import Button from '../ui/Button';
import warningIcon from '../../assets/images/warning.png';
import NoteContainer from '../ui/forms/NoteContainer';

const ApplicantDetails = (props) => { 
   
        const 
        { 
            color,
            state,
            applicantDetails,
            drivLicense,
            licenseStatus,
            myInfoMode
        } = props;

        return (
            <>
                <div data-test-id = 'applicantDetails'>
                    {props.properties.errorMyInfoFailed !== '' ?
                        <ChoiceWrap>
                            <NoteContainer><img src={warningIcon} /> <span>Note:</span></NoteContainer>
                            We are unable to retrieve your information from Singpass. Please fill in your details below to proceed with your application.
                        </ChoiceWrap>
                        :
                        <FormTextWrap>
                            Please verify and update your information.
                        </FormTextWrap>
                    }
                    <FormWrapper>
                        <DoubleWrap>
                            <BoxedInput
                                disabled={applicantDetails.name.source === '1'}
                                type="text"
                                maxLength="200"
                                onChange={props.onChange}
                                onKeyDown={props.onKeyDown}
                                label="Name"
                                name="stage4_name"
                                error={state.stage4_name_error}
                                value={state.stage4_name} />
                            <BoxedInput
                                disabled={applicantDetails.identityNo.source === '1'}
                                type="text"
                                maxLength="10"
                                onChange={props.onChange}
                                onKeyDown={props.onKeyDown}
                                label="NRIC/FIN"
                                name="stage4_nric"
                                error={state.stage4_nric_error}
                                value={state.stage4_nric} />
                        </DoubleWrap>
                        <DoubleWrap>
                            <BoxedInput 
                                id="tdp_dob"
                                disabled={applicantDetails.dob.source === '1'}
                                type="text"
                                onChange={props.onChange}
                                label="Date of Birth"
                                name="stage4_dob"
                                maxLength="11"
                                error={state.stage4_dob_error}
                                value={state.stage4_dob} />
                            <InputWrap>
                                <Label>Gender</Label>
                                <BoxedSelect
                                    isDisabled={applicantDetails.gender.source === '1'}
                                    
                                    onChange={props.onReactSelectChange}
                                    isSearchable={false}
                                    placeholder="Select"
                                    name="stage4_gender"
                                    value={state.stage4_gender}
                                    options=
                                    {
                                        applicantDetails.gender.source === '1' ?
                                            props.properties.gender 
                                            :
                                            props.properties.genderManual 
                                    } />
                                <Label isValidationMsg >{state.stage4_gender_error}</Label>

                            </InputWrap>
                        </DoubleWrap>
                        <DoubleWrap>
                            <InputWrap>
                                <Label>Race</Label>
                                <BoxedSelect
                                    isDisabled={applicantDetails.race.source === '1'}
                                    onChange={props.onReactSelectChange}
                                    isSearchable={false}
                                    placeholder="Select"
                                    name="stage4_race"
                                    value={state.stage4_race}
                                    options={props.properties.race} />
                                <Label isValidationMsg >{state.stage4_race_error}</Label>

                            </InputWrap>
                            <InputWrap>
                                <Label>Marital Status</Label>
                                <BoxedSelect
                                    //always editable    
                                    onChange={props.onReactSelectChange}
                                    isSearchable={false}
                                    placeholder="Select"
                                    name="stage4_maritalStatus"
                                    value={state.stage4_maritalStatus}
                                    options={props.properties.maritalStatus}/>
                                <Label isValidationMsg >{state.stage4_maritalStatus_error}</Label>

                            </InputWrap>
                        </DoubleWrap>
                        <DoubleWrap>
                            <InputWrap>
                                <Label>Nationality</Label>
                                <BoxedSelect
                                    isDisabled={applicantDetails.nationality.source === '1'}
                                    isSearchable={false}
                                    placeholder="Select"
                                    onChange={props.onReactSelectChange}
                                    name="stage4_nationality"
                                    value={state.stage4_nationality}
                                    options={props.properties.nationality}/>
                                <Label isValidationMsg >{state.stage4_nationality_error}</Label>

                            </InputWrap>
                            <InputWrap>
                                <Label>Residential Status</Label>
                                <BoxedSelect
                                    isDisabled={applicantDetails.residentialStatus.source === '1'}
                                    isSearchable={false}
                                    placeholder="Select"
                                    onChange={props.onReactSelectChange}
                                    name="stage4_residentialStatus"
                                    value={state.stage4_residentialStatus}
                                    options=
                                    {
                                        applicantDetails.residentialStatus.source === '1' ?
                                            props.properties.residentialStatus
                                            :
                                            props.properties.residentialStatusManual
                                    } />
                                <Label isValidationMsg >{state.stage4_residentialStatus_error}</Label>

                            </InputWrap>
                        </DoubleWrap>
                        {myInfoMode &&
                            <div>
                                {drivLicense.qdl != null &&
                                    <div>
                                        <InputWrap>
                                            <Label>Driving License</Label>
                                            <BoxedSelect
                                                isDisabled={myInfoMode}
                                                isSearchable={false}
                                                placeholder="Select"
                                                onChange={props.onReactSelectChange}
                                                name="stage4_drivingLicenseQDL"
                                                value={drivLicense.qdl.status}
                                                options={props.properties.drivingLicenseStatus}/>
                                            <Label isValidationMsg>{state.stage4_drivingLicense_error}</Label>
                                        </InputWrap>
                                        {drivLicense.qdl.classes.map((item, index) =>
                                            <DoubleWrap key={"qdlClass" + index}>
                                                <InputWrap>
                                                    <Label>Driving License Class</Label>
                                                    <BoxedSelect
                                                        isDisabled={myInfoMode && applicantDetails.drivingLicense.source === '1'}
                                                        onChange={(e) => props.onHandleLicenseChange(e, "licenseClass", true, index)}
                                                        isSearchable={false}
                                                        placeholder="Select"
                                                        name={"stage4_drivingLicenseClassQDL" + index}
                                                        value={item.licenseClass}
                                                        options=
                                                        {
                                                            applicantDetails.drivingLicense.source === '1' ?
                                                                props.properties.drivingLicenseClass
                                                                :
                                                                props.properties.drivingLicenseManualClasses

                                                        } />
                                                    <div style={{ display: item.licenseClass === '' && state.showLicenseError ? 'block' : 'none' }}>
                                                        <Label isValidationMsg>Required</Label>
                                                    </div>
                                                </InputWrap>
                                                <BoxedInput 
                                                    className='tdp_issueDate'
                                                    disabled={myInfoMode && applicantDetails.drivingLicense.source === '1'}
                                                    type="text"
                                                    maxLength="11"
                                                    onChange={(e) => props.onHandleLicenseChange(e, "issueDate", true, index)}
                                                    label='Driving License Issue Date'
                                                    name={"stage4_licenseIssueDateQDL" + index}
                                                    value={item.issueDate == null ? '' : item.issueDate} 
                                                    error={state.stage4_licenseIssueDate_error}/>
                                            </DoubleWrap>
                                        )}
                                        <DoubleWrap>
                                            <InputWrap>
                                                <Label>Driving License Validity</Label>
                                                <BoxedSelect
                                                    isDisabled={myInfoMode && applicantDetails.drivingLicense.source === '1'}
                                                    onChange={(e) => props.onHandleLicenseChange(e, "validity", true, -1)}
                                                    isSearchable={false}
                                                    placeholder="Select"
                                                    name="stage4_licenseValidityQDL"
                                                    value={drivLicense.qdl.validity}
                                                    options=
                                                    {
                                                        applicantDetails.drivingLicense.source === '1' ?
                                                            props.properties.licenceValidity
                                                            :
                                                            props.properties.drivingLicenseValidityManual
                                                    } />
                                                <Label isValidationMsg>{state.stage4_licenseValidity_error}</Label>
                                            </InputWrap>
                                            <BoxedInput 
                                                className='tdp_expiryDate'
                                                maxLength="11"
                                                type="text"
                                                disabled={myInfoMode && applicantDetails.drivingLicense.source === '1'}
                                                onChange={(e) => props.onHandleLicenseChange(e, "expirydate", true, -1)}
                                                label="Driving License Expiry Date"
                                                name="stage4_licenseExpiryDateQDL"
                                                value={drivLicense.qdl.expirydate} 
                                                error={state.stage4_licenseExpiryDate_error}/>
                                        </DoubleWrap>
                                    </div>
                                    // QDL END 
                                }
                                {drivLicense.pdl != null &&
                                    <div>
                                        <InputWrap>
                                            <Label>Driving License</Label>
                                            <BoxedSelect
                                                isDisabled={myInfoMode && applicantDetails.drivingLicense.source === '1'}
                                                onChange={(e) => props.onHandleLicenseChange(e, "status", false, -1)}
                                                isSearchable={false}
                                                placeholder="Select"
                                                name="stage4_drivingLicensePDL"
                                                value={drivLicense.pdl.status}
                                                options={props.properties.drivingLicenseStatus} />
                                            <Label isValidationMsg>{state.stage4_drivingLicense_error}</Label>
                                        </InputWrap>
                                        {drivLicense.pdl.classes.map((item, index) =>
                                            <InputWrap key={"pdlClass" + index}>
                                                <Label>Driving License Class</Label>
                                                <BoxedSelect
                                                    isDisabled={myInfoMode && applicantDetails.drivingLicense.source === '1'}
                                                    onChange={(e) => props.onHandleLicenseChange(e, "licenseClass", false, index)}
                                                    isSearchable={false}
                                                    placeholder="Select"
                                                    name={"stage4_drivingLicenseClassPDL" + index}
                                                    value={item.licenseClass}
                                                    options=
                                                    {
                                                        applicantDetails.drivingLicense.source === '1' ?
                                                            props.properties.drivingLicenseClass
                                                            :
                                                            props.properties.drivingLicenseManualClasses
                                                    } />
                                                <Label isValidationMsg>{state.stage4_drivingLicenseClass_error}</Label>
                                            </InputWrap>
                                        )}
                                        <DoubleWrap>
                                            <InputWrap>
                                                <Label>Driving License Validity</Label>
                                                <BoxedSelect
                                                    isDisabled={myInfoMode && applicantDetails.drivingLicense.source === '1'}
                                                    onChange={(e) => props.onHandleLicenseChange(e, "validity", true, -1)}
                                                    isSearchable={false}
                                                    placeholder="Select"
                                                    name="stage4_licenseValidityPDL"
                                                    value={drivLicense.pdl.validity}
                                                    options=
                                                    {
                                                        applicantDetails.drivingLicense.source === '1' ?
                                                            props.properties.licenceValidity
                                                            :
                                                            props.properties.drivingLicenseValidityManual
                                                    } />
                                                <Label isValidationMsg>{state.stage4_licenseValidity_error}</Label>
                                            </InputWrap>
                                            <BoxedInput
                                                className='tdp_expiryDate'
                                                maxLength="11"
                                                type="text"
                                                disabled={myInfoMode && applicantDetails.drivingLicense.source === '1'}
                                                onChange={(e) => props.onHandleLicenseChange(e, "expirydate", false, -1)}
                                                label="Driving License Expiry Date"
                                                name="stage4_licenseExpiryDatePDL"
                                                value={drivLicense.pdl.expirydate}
                                                error={state.stage4_licenseExpiryDate_error} />
                                        </DoubleWrap>
                                    </div>
                                    // PDL END 
                                }
                            </div>
                        }
                        {((!myInfoMode || (!drivLicense.pdl && !drivLicense.qdl)) &&
                            <InputWrap>
                                <Label>Driving License</Label>
                                <BoxedSelect
                                    isDisabled={myInfoMode && applicantDetails.drivingLicense.source === '1'}
                                    isSearchable={false}
                                    placeholder="Select"
                                    onChange={props.onReactSelectChange}
                                    name="stage4_drivingLicense"
                                    value={state.stage4_drivingLicense}
                                    options={props.properties.drivingLicenseStatus} />
                                <Label isValidationMsg>{state.stage4_drivingLicense_error}</Label>
                            </InputWrap>
                        )}
                        {(!myInfoMode && state.stage4_drivingLicense.toUpperCase() !== 'NOT APPLICABLE' &&
                            <div>
                                {(myInfoMode ? licenseStatus.toUpperCase() : state.stage4_drivingLicense.toUpperCase()) === 'QUALIFIED' ?
                                    <div>
                                        <DoubleWrap>
                                            <InputWrap>
                                                <Label>Driving License Class</Label>
                                                <BoxedSelect
                                                    isDisabled={myInfoMode && applicantDetails.drivingLicense.source === '1'}
                                                    onChange={props.onReactSelectChange}
                                                    isSearchable={false}
                                                    placeholder="Select"
                                                    name="stage4_drivingLicenseClass"
                                                    value={state.stage4_drivingLicenseClass}
                                                    options={props.properties.drivingLicenseManualClasses}/>
                                                <Label isValidationMsg>{state.stage4_drivingLicenseClass_error}</Label>
                                            </InputWrap>
                                            {(myInfoMode ? licenseStatus.toUpperCase() : state.stage4_drivingLicense.toUpperCase()) === 'QUALIFIED' &&
                                                <BoxedInput 
                                                    className='tdp_issueDate'
                                                    disabled={myInfoMode && applicantDetails.drivingLicense.source === '1'}
                                                    maxLength="11"
                                                    type="text"
                                                    onChange={props.onChange}
                                                    label="Driving License Issue Date"
                                                    name="stage4_licenseIssueDate"
                                                    value={state.stage4_licenseIssueDate}
                                                    error={state.stage4_licenseIssueDate_error} />
                                            }
                                        </DoubleWrap>
                                        <DoubleWrap>
                                            <InputWrap>
                                                <Label>Driving License Validity</Label>
                                                <BoxedSelect
                                                    isDisabled={myInfoMode && applicantDetails.drivingLicense.source === '1'}
                                                    onChange={props.onReactSelectChange}
                                                    isSearchable={false}
                                                    placeholder="Select"
                                                    name="stage4_licenseValidity"
                                                    value={state.stage4_licenseValidity}
                                                    options=
                                                    {
                                                        applicantDetails.drivingLicense.source === '1' ?
                                                            props.properties.licenceValidity
                                                            :
                                                            props.properties.drivingLicenseValidityManual
                                                    } />
                                                <Label isValidationMsg>{state.stage4_licenseValidity_error}</Label>
                                            </InputWrap>
                                            <BoxedInput 
                                                className='tdp_expiryDate'
                                                maxLength="11"
                                                type="text"
                                                disabled={myInfoMode && applicantDetails.drivingLicense.source === '1'}
                                                onChange={props.onChange}
                                                label="Driving License Expiry Date"
                                                name="stage4_licenseExpiryDate"
                                                value={state.stage4_licenseExpiryDate}
                                                error={state.stage4_licenseExpiryDate_error} />
                                        </DoubleWrap>
                                    </div>
                                    :
                                    <div>
                                        <InputWrap>
                                            <Label>Driving License Class</Label>
                                            <BoxedSelect
                                                isDisabled={myInfoMode && applicantDetails.drivingLicense.source === '1'}
                                                onChange={props.onReactSelectChange}
                                                isSearchable={false}
                                                placeholder="Select"
                                                name="stage4_drivingLicenseClass_pdl"
                                                value={state.stage4_drivingLicenseClass_pdl}
                                                options={props.properties.drivingLicenseManualClasses}/>
                                            <Label isValidationMsg>{state.stage4_drivingLicenseClass_pdl_error}</Label>
                                        </InputWrap>
                                        <DoubleWrap>
                                            <InputWrap>
                                                <Label>Driving License Validity</Label>
                                                <BoxedSelect
                                                    isDisabled={myInfoMode && applicantDetails.drivingLicense.source === '1'}
                                                    onChange={props.onReactSelectChange}
                                                    isSearchable={false}
                                                    placeholder="Select"
                                                    name="stage4_licenseValidity_pdl"
                                                    value={state.stage4_licenseValidity_pdl}
                                                    options=
                                                    {
                                                        applicantDetails.drivingLicense.source === '1' ?
                                                            props.properties.licenceValidity
                                                            :
                                                            props.properties.drivingLicenseValidityManual
                                                    } />
                                                <Label isValidationMsg>{state.stage4_licenseValidity_pdl_error}</Label>
                                            </InputWrap>
                                            <BoxedInput 
                                                className='tdp_expiryDate'
                                                type="text"
                                                maxLength="11"
                                                disabled={myInfoMode && applicantDetails.drivingLicense.source === '1'}
                                                onChange={props.onChange}
                                                label="Driving License Expiry Date"
                                                name="stage4_licenseExpiryDate_pdl"
                                                value={state.stage4_licenseExpiryDate_pdl}
                                                error={state.stage4_licenseExpiryDate_pdl_error} />
                                        </DoubleWrap>
                                    </div>
                                }

                            </div>
                        )
                        }
                        {
                            !myInfoMode &&
                            <InputWrap>
                                <Label>Upload Supporting Document  <br />(Front and Back of NRIC/Employement Pass/Passport and Payslip)</Label>
                                <DoubleWrap>
                                    <Label>NRIC/Passport:</Label>
                                    <InputWrap>
                                        {
                                            state.stage4_files_nric.map((i, idx) =>
                                                <File key={idx}>
                                                    <FileLabelWrapper>{i.name}</FileLabelWrapper>
                                                    <FileClose onClick={() => props.onFileRemove('stage4_file_nric_Close', i)}><span>✕</span></FileClose>
                                                </File>)
                                        }
                                        {
                                            state.stage4_files_nric.length < 2 &&
                                            <FileButton isMultiple={state.stage4_files_nric.length > 0}>
                                                Upload File
                                                <FileUpload
                                                    name="stage4_files_nric"
                                                    type="file"
                                                    onChange={props.onFileUpload}
                                                    accept="image/x-png,image/gif, image/jpeg, image/jpg, image/tif, image/tiff, image/bmp, application/pdf"
                                                    multiple />
                                            </FileButton>
                                        }
                                        <Label isValidationMsg>{state.stage4_file_error}</Label>
                                    </InputWrap>
                                </DoubleWrap>
                                <DoubleWrap>
                                    <Label>Payslip:</Label>
                                    <InputWrap>
                                        {
                                            state.stage6_files.map((i, idx) =>
                                                <File key={idx}>
                                                    <FileLabelWrapper>{i.name}</FileLabelWrapper>
                                                    <FileClose onClick={() => props.onFileRemove('stage6_fileClose', i)}><span>✕</span></FileClose>
                                                </File>)
                                        }
                                        {
                                            state.stage6_files.length < 5 &&
                                            <FileButton isMultiple={state.stage6_files.length > 0}>
                                                Upload File
                                                <FileUpload
                                                    name="stage6_fileupload"
                                                    type="file"
                                                    onChange={props.onFileUpload}
                                                    accept="image/x-png,image/gif, image/jpeg, image/jpg, image/tif, image/tiff, image/bmp, application/pdf"
                                                    multiple />
                                            </FileButton>
                                        }
                                        <Label isValidationMsg>{state.stage6_file_error}</Label>
                                    </InputWrap>
                                </DoubleWrap>
                            </InputWrap>
                        }
                        {
                            !myInfoMode &&
                            <InputWrap>
                                <Label>Other Supporting Documents</Label>
                                {
                                    state.stage4_files.map((i, idx) =>
                                        <File key={idx}>
                                            <FileLabelWrapper>{i.name}</FileLabelWrapper>
                                            <FileClose onClick={() => props.onFileRemove('stage4_fileClose', i)}><span>✕</span></FileClose>
                                        </File>)
                                }
                                {state.stage4_files.length < 5 &&
                                    <FileButton isMultiple={state.stage4_files.length > 0}>
                                        Upload File
                                        <FileUpload
                                            name="stage4_files"
                                            type="file"
                                            onChange={props.onFileUpload}
                                            accept="image/x-png,image/gif, image/jpeg, image/jpg, image/tif, image/tiff, image/bmp, application/pdf"
                                            multiple />
                                    </FileButton>
                                }
                            </InputWrap>
                        }
                    </FormWrapper>
                    <Button onClick={() => props.onVerifyApplicant()}>
                        Next
                    </Button>
                </div>
            </>
        );
    };

export default ApplicantDetails;
